import * as Yup from "yup";

export const formValidationPersonal = Yup.object().shape({
    vendor_name: Yup.string().required("Full Name is required !")
});
